/**
 * Format number to US currency.
 * @param {number} number Number to format.
 * @returns {string}
 */
function toUSCurrency(number) {
  const formattedPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
  return formattedPrice;
}

export const currencyUtils = {
  toUSCurrency,
};
